/**
 * type 따라 Modal을 연다.
 * @param {*} state
 * @param {Object} param1 action에서 전달 받은 object
 * @param {string} param1.type - 모달 타입 (type: 모달 타입, message: 모달에 표시할 값, callback: 모달이 닫힌 후 실행할 함수)
 * @param {string} param1.header - 모달에 표시할 값 (type: 모달 타입, header: , callback: 모달이 닫힌 후 실행할 함수)
 * @param {string} param1.message - 모달에 표시할 값 (type: 모달 타입, message: , callback: 모달이 닫힌 후 실행할 함수)
 * @param {boolean} param1.canCancel - 취소 버튼을 표시할지 여부
 * @param {Function} param1.callback - 확인 버튼 눌렀을 시 실행할 함수
 * @param {Function} param1.cancelCallback - 모달이 닫힌 후 실행할 함수2
 */
const OPEN_MODAL = (
  state,
  {
    type,
    header,
    message,
    canCancel,
    callback,
    cancelCallback,
    closeCallback,
    confirmText,
    noFooter,
    showFooterInSecond
  }
) => {
  if (state.open.hasOwnProperty(type)) {
    state.open[type] = true
  }
  if (typeof header === 'string') {
    state.header = header
  }
  if (typeof message === 'string') {
    state.message = message
  }

  if (typeof canCancel === 'boolean') {
    state.canCancel = canCancel
  } else {
    state.canCancel = false
  }

  if (typeof callback === 'function') {
    state.callback = callback
  }
  if (typeof cancelCallback === 'function') {
    state.cancelCallback = cancelCallback
  }

  if (typeof closeCallback === 'function') {
    state.closeCallback = closeCallback
  }

  if (typeof confirmText === 'string') {
    state.confirmText = confirmText
  } else {
    state.confirmText = '확인'
  }

  if (typeof noFooter === 'boolean') {
    state.noFooter = noFooter
  }

  if (typeof showFooterInSecond === 'number') {
    state.showFooterInSecond = showFooterInSecond
  }
}
/**
 * 모달을 닫는다.
 * @param {*} state
 */
const CLOSE_MODAL = state => {
  for (let key in state.open) {
    state.open[key] = false
  }
  state.header = ''
  state.message = ''
  // state.canCancel = false
  state.callback = null
  state.cancelCallback = null
  state.closeCallback = null
  state.confirmText = null
  // state.noFooter = false
}

const SET_NO_FOOTER = (state, noFooter) => {
  state.noFooter = noFooter
}

export default {
  OPEN_MODAL,
  CLOSE_MODAL,
  SET_NO_FOOTER
}
